import { render, staticRenderFns } from "./FollowRulesModal.vue?vue&type=template&id=1c68f456&scoped=true&"
import script from "./FollowRulesModal.vue?vue&type=script&lang=ts&"
export * from "./FollowRulesModal.vue?vue&type=script&lang=ts&"
import style0 from "./FollowRulesModal.vue?vue&type=style&index=0&id=1c68f456&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c68f456",
  null
  
)

export default component.exports